module.exports = __webpack_public_path__ + "img/icon-no-data.f3a1cefb.svg";